import React from "react";
import { BarChart } from "./barChart";
import { LineChart } from "./lineChart";
import { Treemap } from "./treeMap";
import { DoughnutChart } from "./doughnutChart";
import { setListingData } from "../../store/listing/listingSlice";
import { useDispatch } from "react-redux";
import { DataListTemplates } from "../../common/constants";
import { StackedBarChart } from "./stackedBarChart";
import { getDateRangeForPeriod } from "../../common/graphHelper";
import { other } from "../../common/labelConstants";

const _props = {
 chartType: '',
 setReset:()=>{},
 config:{}
};

export const ChartCall = (props = _props) => {
  const chart = props.chartType.toLowerCase();
  const dispatch = useDispatch();
  

  const clickFilter = (e, activeEls, data) => {
    props.setReset(true);
    if (activeEls && !activeEls[0]) {
      return;
    }
    const obj = {
      a: props.config.graphConfig.dataPoint,
    };
    
    dispatch(
      setListingData({
        fields: (data.labels)
          ? [{ name: obj.a, value: (data.labels[activeEls[0].index]===other)?null:data.labels[activeEls[0].index] }] //for doughnut
          : [{ name: obj.a, value: (data.data.name===other)?null:data.data.name }], //for treemap
        template: props.config.dataListTemplate,
      })
    );
  };
  

  const legendFilter = (x) => {
    props.setReset(true);
    dispatch(
      setListingData({
        fields: [{ name: props.config.graphConfig.dataPoint, value: x===other?null:x }],
        template: props.config.dataListTemplate,
      })
    );
  };

  const newsClickFilter = (e, activeEls, data) => {
    props.setReset(true);
    if (activeEls && !activeEls[0]) {
      return;
    }
    data.labels
      ? props.config.setSourceName(data.labels[activeEls[0].index])
      :props.config.setSourceName(data.data.name);
  };

  const newsLegendFilter = (x) => {
    props.setReset(true);
    props.config.setSourceName(x);
  };


  const barClickFilter = (e, activeEls, data) => {
    props.setReset(true);
    if (activeEls && !activeEls[0]) {
      return;
    }

    var filter_value
    if(props.config.graphConfig.dataPoint && props.config.graphConfig.period){

      filter_value = (data.datasets[activeEls[0].datasetIndex].label==other)?null:data.datasets[activeEls[0].datasetIndex].label;
    }
    else if(props.config.graphConfig.dataPoint && !props.config.graphConfig.period){
      filter_value = (data.labels[activeEls[0].index]==other)?null:data.labels[activeEls[0].index]
    }
    dispatch(
      setListingData({
        fields: [props.config.graphConfig.period ?{ name:'createdOn', value: getDateRangeForPeriod(data.labels[activeEls[0].index],props.config.period),type:'range'}:{},
        props.config.graphConfig.dataPoint ? 
        {
          name: props.config.graphConfig.dataPoint,
          value: filter_value
        } : {}] ,
      
        template: props.config.dataListTemplate,
      })
    );
  };

  
  var actionClick;
  var actionLegendClick;
  if(props.config.dataListTemplate===DataListTemplates.news){
    actionClick=newsClickFilter;
    actionLegendClick=newsLegendFilter;
  }else{
    actionClick=clickFilter;
    actionLegendClick=legendFilter;
  }
  


  switch (chart) {
    case "bar":
      if(props.config.graphConfig.dataPoint && props.config.graphConfig.period){
      return (
        <StackedBarChart {...props.config}
        clickFilter={barClickFilter}
        />
      )}else{
        return(
        <BarChart {...props.config} setReset={props.setReset}
        clickFilter={barClickFilter}
        />)
      }

    case "line":
      return (
        <LineChart {...props.config}
        />
      );

    case "treemap":
      return(
        <Treemap {...props.config}
        clickFilter={actionClick}
        setReset={props.setReset}
        />
      );

      case "doughnut":
      return(
        <DoughnutChart {...props.config}
        
        clickFilter={actionClick}
        legendFilter={actionLegendClick}
        />
      );

    default:
      return (
        <></>
      );
  }
};
